var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('div',[(_vm.claimed)?_c('ClaimedUserView',{attrs:{"pro_user":_vm.unclaimedProUser}}):_c('UnclaimedUserView',{attrs:{"pro_user":_vm.unclaimedProUser}})],1):_c('div')}
var staticRenderFns = []

export { render, staticRenderFns }